import { render, staticRenderFns } from "./expressPop.vue?vue&type=template&id=9385040e&scoped=true"
import script from "./expressPop.vue?vue&type=script&lang=js"
export * from "./expressPop.vue?vue&type=script&lang=js"
import style0 from "./expressPop.vue?vue&type=style&index=0&id=9385040e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9385040e",
  null
  
)

export default component.exports